import React from "react"
import { TableHeaderColumn, TableRow, TableHeader, TableRowColumn, TableBody } from "material-ui"
import strings from "../../../localization/strings"
import Table from "../../../components/common/Table"
import { IEmployeeFileDocument } from "../../../models"
import moment from "moment"
import { grey700 } from "material-ui/styles/colors"

interface IProps {
    readonly: boolean
    files: IEmployeeFileDocument[]
    selectedFile: IEmployeeFileDocument
    total: number
    offset: number
    limit: number
    limitOptions: number[]
    onPageClick(offset: number): void
    onLimitChange(limit: number): void
    handleSelectFile(selectedFile: IEmployeeFileDocument): void
}

const UserDetailsFilesTable: React.SFC<IProps> = (props: IProps) => {
    return (
        <Table
            readonly={props.readonly}
            singleSelectable
            allowClickRow
            unClickableCols={[0, 1]}
            items={props.files}
            handleSelect={selectedFiles => props.handleSelectFile(selectedFiles.length > 0 ? selectedFiles[0] : null)}
            total={props.total}
            offset={props.offset}
            limit={props.limit}
            limitOptions={props.limitOptions}
            onPageClick={props.onPageClick}
            onLimitChange={props.onLimitChange}
        >
            <TableHeader>
                <TableRow>
                    <TableHeaderColumn>{strings.File_Name}</TableHeaderColumn>
                    <TableHeaderColumn style={{ width: 75 }}>{strings.Date}</TableHeaderColumn>
                    <TableHeaderColumn style={{ width: 150 }}>{strings.Added_By}</TableHeaderColumn>
                    <TableHeaderColumn style={{ width: 75, textAlign: "center" }}>{strings.Download}</TableHeaderColumn>
                </TableRow>
            </TableHeader>
            <TableBody deselectOnClickaway={false}>
                {props.files.map((file, index) => {
                    //test
                    const downloadLink = `${api_url()}/employeefiles/download/${file.Id}`
                    return (
                        <TableRow data-intercom-target={index === 0 && "menu-UserDetails-File"} key={index} selected={props.selectedFile && props.selectedFile.Id === file.Id}>
                            <TableRowColumn >{file.SubType.Name}</TableRowColumn>
                            <TableRowColumn style={{ width: 75 }}>{moment(file.ObjectAudit.LastModified).format("MM/DD/YYYY")}</TableRowColumn>
                            <TableRowColumn style={{ width: 150 }}>{file.ObjectAudit.LastModifiedByName}</TableRowColumn>
                            <TableRowColumn style={{ width: 75, textAlign: "center" }}>
                                <a href={downloadLink} target="_blank">
                                    <i
                                        className="fa fa-download"
                                        style={{ fontSize: 20, color: grey700 }}
                                    />
                                </a>
                            </TableRowColumn>
                        </TableRow>
                    )
                }
                )}
            </TableBody>
        </Table>
    )
}

export default UserDetailsFilesTable